"use client";

import { PortableText } from "next-sanity";
import { richTextComponent } from "@/sanity/sanityPortableText";
import { CTAButton } from "@/shadcn/ui/button";
import { PageAnniversarySchema } from "@/sanity/pages/PageAnniversaryTemplate";
import Image from "@/helpers/Image";
import dots from "@/public/anniversary/dots.png";

export default function OfferSection({
  data,
}: {
  data: PageAnniversarySchema;
}) {
  const hasContent = data.offerImage || data.offerTitle || data.offerBody;
  if (!hasContent) return null;

  return (
    <section className="relative w-full bg-[#001b14] py-[8rem] lg:py-[14rem]">
      <Image
        src={dots}
        alt="dots"
        className="absolute inset-0 !w-full lg:!w-[50%] !h-full object-cover mix-blend-exclusion"
      />
      <Image
        src={dots}
        alt="dots"
        className="hidden lg:block absolute top-0 right-0 !w-[50%] !h-full object-cover mix-blend-exclusion"
      />
      <div className="mx-auto w-[min(170rem,100%)] px-[3rem] lg:px-[0rem]">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-[6rem] lg:gap-[12rem]">
          {/* Left: Sanity image (funding card) */}
          {data.offerImage && (
            <div className="w-full lg:w-[81.625rem] flex-shrink-0">
              <Image
                src={data.offerImage}
                alt=""
                className="!w-full"
                quality={100}
              />
            </div>
          )}

          {/* Right: text content */}
          <div className="flex flex-col flex-1">
            {data.offerChip && (
              <p className="mb-[1rem] font-gestura italic text-[2.25rem] leading-[1.5] text-white font-light">
                {data.offerChip}
              </p>
            )}

            {data.offerTitle && (
              <div className="mb-[2rem] lg:mb-[7rem] richtext richtext-start prose-headings:font-normal prose-headings:text-white prose-p:text-white max-sm:prose-headings:text-[5rem] lg:prose-headings:text-[8rem]">
                <PortableText
                  value={data.offerTitle}
                  components={richTextComponent}
                />
              </div>
            )}

            {data.offerBody && (
              <div
                className="richtext richtext-start mb-[2.5rem] prose-p:mb-0 prose-p:text-[2.25rem] prose-p:leading-[1.5] prose-p:text-white/70 max-w-[70.5rem]"
                style={{ textWrapStyle: "pretty" }}
              >
                <PortableText
                  value={data.offerBody}
                  components={richTextComponent}
                />
              </div>
            )}

            {data.offerCTA && (
              <div className="w-full lg:w-fit">
                <CTAButton data={data.offerCTA} />
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
